const hasFiniteNumber = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  Number.isFinite(Number(value));

export const getSalesCompPercent = (sales, priorYearSales) => {
  if (!hasFiniteNumber(sales) || !hasFiniteNumber(priorYearSales)) {
    return null;
  }

  const priorYearNumber = Number(priorYearSales);
  if (priorYearNumber <= 0) return null;

  const comp = ((Number(sales) - priorYearNumber) / priorYearNumber) * 100;
  return Number.isFinite(comp) ? comp : null;
};
